import { useAgentsByIds } from "~/hooks/useAgentList";
import type { Agent } from "~/services/agents";

// Session rows and featured entries name their agents by id only, so a project
// list resolves the ids itself. Most resolve for free against the project's
// already-loaded agents. Only the ids missing from that set (e.g. an agent since
// removed from the project) are looked up by id, so such an agent keeps its
// avatar. The lookup omits an agent that is deleted or that the caller can't
// view, and that id stays unresolved.
export const useProjectAgentsById = (
  agentIds: readonly (string | null)[],
  attachedAgents: Agent[] | undefined
): Map<string, Agent> => {
  const agentsById = new Map((attachedAgents ?? []).map((a) => [a.id, a]));
  const { data: lookedUpAgents } = useAgentsByIds(
    agentIds.filter((id): id is string => id != null && !agentsById.has(id))
  );
  for (const agent of lookedUpAgents ?? []) {
    agentsById.set(agent.id, agent);
  }
  return agentsById;
};
